<template>
  <div class="innerBox">
    <h2 class="mb-4">Admin Authorization</h2>

	<h4>Pending Authorization</h4>

    <vue-universal-table
	  v-if="data"
	  :data="data"
      :buttons="vue_universal_table.buttons"
      @onApproved="approved"
      @onReject="reject"
    ></vue-universal-table>

	<hr>

	<h4>Last 10 Request Authorization</h4>

    <vue-universal-table
	  v-if="dataHistory"
	  :data="dataHistory"
    ></vue-universal-table>


  </div>
</template>

<script>
import moment from 'moment'

export default {
	data () {
		return {
			data : null,
			dataHistory : null,
			vue_universal_table : {
				buttons : [{
					title : 'Approved',
					variable : 'request_number',
					class : 'btn btn-outline-success fa fa-check'
				},{
					title : 'Reject',
					variable : 'request_number',
					class : 'btn btn-outline-danger fa fa-times'
				}]
			}
		}
	},
	mounted () {
		this.getRequestList('PENDING')
		this.getRequestList()
	},
	methods : {
		getRequestList (status) {
			let url = '/api/v1/check/list?'

			if(status) url += ('status=' + status)

			this.$http.get(url)
			.then((resp) => {
				let data = resp.data.data

				for(var i = 0 ; i < data.length ; i++) {

					
					

					if(data[i].request_description.includes('__')) {
						let splitString = data[i].request_description.split('__')
						data[i].car_detail = splitString[1]
						data[i].request_description = splitString[0]
					}
					data[i].time_of_request = moment(data[i].request_time).format('MMM DD Y, HH:mm')

					if(data[i].approval_time) {
						data[i].time_of_approval = moment(data[i].approval_time).format('MMM DD Y, HH:mm')
						delete data[i].approval_time
					} 
					// data[i].request_time = moment(data[i].request_time).format('MMM DD Y, HH:mm')
					delete data[i].request_time
				}
				if(status )
					this.data = data
				else {
					this.dataHistory = data
				}
			})
			.catch((err) => {
				console.log(err)
			})
		},
		approved (id) {
			this.changeStatus(id , 'APPROVED')
		},
		reject (id) {
			this.changeStatus(id , 'REJECTED')
		},
		changeStatus (id , status) {
			this.$http.put('/api/v1/check/' + id, {status : status})
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Request Has Successfully Been Request'])
				this.data = null
				this.getRequestList()
				this.getRequestList('PENDIN')
			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>
